import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showSuccessMessage = (message) => {
  toast.success(message, toastOptions);
};

export const showErrorMessage = (error) => {
  let message = "An unexpected error occurred";
  if (typeof error === "string") {
    message = error;
  } else if (error?.response?.data) {
    const data = error.response.data;
    if (data.message) {
      message = data.message;
    } else if (data.errors && typeof data.errors === "object") {
      message = Object.values(data.errors).flat().join(", ");
    }
  } else if (error?.message) {
    message = error.message;
  }
  toast.error(message, toastOptions);
};

export const showInfoMessage = (message) => {
  toast.info(message, toastOptions);
};

export const showWarningMessage = (message) => {
  toast.warning(message, toastOptions);
};